import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertContact, ContactVerification } from 'app/shared/models/Alerts';
import { AnnouncementsService } from 'app/layout/announcements/announcements.service';
import { EvoToastr } from 'app/shared/services/EvoToastr.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EvoPatternValidator } from 'app/shared/validators/evo-pattern-validator.directive';
import { FormatService } from 'app/shared/services/format.service';
import { FormsValidationService } from 'app/shared/services/formsValidation.service';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { BindingContext } from 'app/shared/models/BindingContext';

@Component({
    selector: 'contact-verify-modal',
    styleUrls: ['./contact-verify.component.scss'],
    templateUrl: 'contact-verify.component.html',
})
export class ContactVerifyComponent {
    public title = "Verify Contact";
    public verifyType = 'Email';
    public contactIsEmail: boolean = true;
    public verifyBindingContext: BindingContext = new BindingContext();
    public resendBindingContext:BindingContext = new BindingContext();
    public contactData: string;
    public code: string = '';

    constructor(public activeModal: NgbActiveModal,
        private annSvc: AnnouncementsService,
        private toastSvc: EvoToastr,
        private formatSvc: FormatService,
        private formSvc: FormsValidationService, ) {

    }

    ngOnInit() {
        if (this.contactIsEmail) {
            this.title = 'Verify Email';
        } else {
            this.title = 'Verify Phone';
            this.verifyType = 'Phone';
        }
    }


    onModalSubmit() {
        //I don't think there is a submit
        this.activeModal.close(true);
    }

    /**
       * Parses the form value for Email verification code and submits to the server
       * Updates the message and status on resp
       */
    verifyEmail() {
        this.verifyBindingContext.beginGet();
        let temp: ContactVerification = new ContactVerification();
        temp.Code = this.code;
        temp.Email = this.contactData;
        // temp.SMSPhone = this.defaultForm.controls['defaultSMS'].value;
        this.annSvc.VerifyEmailContactVerification(temp).then(resp => {
            //Verified successfully
            this.toastSvc.toastSuccess('Success', 'Verified email.');
            this.verifyBindingContext.endGet();
            this.onModalSubmit();
        }).catch(err => {
            //Verification failed
            this.verifyBindingContext.endGet();
            this.toastSvc.toastFailure('Error', 'Failed to verify email. Please try again.');
        });
    }

    resendEmail() {
        this.resendBindingContext.beginGet();
        let temp: ContactVerification = new ContactVerification();
        temp.Code = this.code;
        temp.Email = this.contactData;
        this.annSvc.InsertEmailContactVerification(temp).subscribe(resp => {
            this.resendBindingContext.endGet();
            this.toastSvc.toastSuccess('Success', 'Re-sent verification email.');
        }, err => {
            //nothing we can do really
            this.resendBindingContext.endGet();
            this.toastSvc.toastFailure('Error', 'Failed to re-send verification email. Please contact support if this issue persists.');
        });
    }

    /**
     * Parses the form value for SMS verification code and submits to the server
     * Updates the message and status on resp
     */
    verifySMS() {
                this.verifyBindingContext.beginGet();
        let temp: ContactVerification = new ContactVerification();
        temp.Code = this.code;
        temp.SMSPhone = this.contactData;
        this.annSvc.VerifySMSContactVerification(temp).then(resp => {
            //Verified successfully
            this.toastSvc.toastSuccess('Success', 'Verified phone.');
            this.verifyBindingContext.endGet();
            this.onModalSubmit();
        }).catch(err => {
            //Verification failed
            this.verifyBindingContext.endGet();
            this.toastSvc.toastFailure('Error', 'Failed to verify phone. Please try again.');
        });
    }

    resendSMS() {
        this.resendBindingContext.beginGet();
        let temp: ContactVerification = new ContactVerification();
        temp.Code = this.code;
        temp.SMSPhone = this.contactData;
        this.annSvc.InsertSMSContactVerification(temp).subscribe(resp => {
            this.resendBindingContext.endGet();
            this.toastSvc.toastSuccess('Success', 'Re-sent verification phone.');
        }, err => {
            this.resendBindingContext.endGet();
            this.toastSvc.toastFailure('Error', 'Failed to re-send verification phone. Please contact support if this issue persists.');
        });
    }

    resendCode() {
        if (this.contactIsEmail) {
            this.resendEmail();
        } else {
            this.resendSMS();
        }
    }

    verify() {
        if (this.contactIsEmail) {
            this.verifyEmail();
        } else {
            this.verifySMS();
        }
    }

}
